import DatePicker from './date-picker';
import './date-picker.scss';

export default DatePicker;
